"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stopKeepAwake = exports.tryKeepAwake = void 0;
let isSupported = true;
let wakeLock = null;
const navigator = window.navigator;
if (!navigator.wakeLock) {
    isSupported = false;
}
function tryKeepAwake() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!isSupported) {
            console.error("Can't keep awake because wakeLock not in navigator", navigator, navigator.wakeLock);
            return;
        }
        // create an async function to request a wake lock
        try {
            wakeLock = yield navigator.wakeLock.request('screen');
            console.log('[WAKE] Wake Lock is active!');
            wakeLock.addEventListener('release', () => {
                // the wake lock has been released
                console.log('[WAKE] Wake Lock has been released');
            });
            document.addEventListener('visibilitychange', () => __awaiter(this, void 0, void 0, function* () {
                if (wakeLock !== null && document.visibilityState === 'visible') {
                    wakeLock = yield navigator.wakeLock.request('screen');
                }
            }));
        }
        catch (err) {
            console.log("[WAKE] Wake Lock couldn't activate!");
            // The Wake Lock request has failed - usually system related, such as battery.
            console.error(err);
        }
    });
}
exports.tryKeepAwake = tryKeepAwake;
function stopKeepAwake() {
    return __awaiter(this, void 0, void 0, function* () {
        return wakeLock.release()
            .then(() => {
            wakeLock = null;
        });
    });
}
exports.stopKeepAwake = stopKeepAwake;
